// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Helvetica.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/HelveticaLTStd-Roman.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/HelveticaLTStd-Fractions.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/HelveticaLTStd-Comp.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/HelveticaLTStd-BlkCond.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/helvetica-world-bold-1.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/HelveticaLTStd-Obl.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/Helvetica-Roman-SemiB.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/HelveticaLTStd-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/HelveticaLTStd-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/helvetica-world-regular-1.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Helvetica";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "helvetica-lt-std-roman";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "helvetica-lt-std-fraction";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "HelveticaLTStd";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "HelveticaLTStd-BlkCond";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "helvetica-world-bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "HelveticaLTStd-Obl";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Helvetica-Roman-SemiB";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "helvetica-lt-std-bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "helvetica-lt-std-light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "helvetica-world-regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  background-color: #F8FAFC;
  color: #0F172A;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #FAEFF5;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #A72C68;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #921F58;
}

.remove-cursor {
  pointer-events: none;
}

.cursor {
  height: max-content;
  cursor: pointer;
}

/* Sweet Alert z-index fix */
.swal2-container {
  z-index: 999999;
}

.swal2-popup {
  border-radius: 20px !important;
  padding: 2rem !important;
  font-family: "helvetica-lt-std-roman", Helvetica, Arial, sans-serif !important;
}

.swal2-title {
  color: #0F172A !important;
  font-family: "helvetica-lt-std-bold", Helvetica, Arial, sans-serif !important;
}

.swal2-confirm {
  border-radius: 10px !important;
  padding: 10px 24px !important;
  font-weight: 500 !important;
  background: linear-gradient(135deg, #A72C68 0%, #921F58 100%) !important;
  box-shadow: 0 4px 6px -1px rgba(167, 44, 104, 0.3) !important;
}

.swal2-confirm:hover {
  background: linear-gradient(135deg, #921F58 0%, #7E1A4C 100%) !important;
}

.swal2-cancel {
  border-radius: 10px !important;
  padding: 10px 24px !important;
  font-weight: 500 !important;
  background: #fff !important;
  color: #6B7280 !important;
  border: 1px solid #E5E7EB !important;
}

.swal2-cancel:hover {
  background: #FAEFF5 !important;
  color: #A72C68 !important;
  border-color: #F0CDDB !important;
}

.stickyTop {
  position: fixed;
  top: 0;
}

/* MUI table pagination fix */
.MuiTablePagination-selectLabel {
  margin-bottom: 0 !important;
}

.MuiTablePagination-displayedRows {
  margin-bottom: 0 !important;
}

/* Smooth page transitions */
.page-enter {
  opacity: 0;
  transform: translateY(8px);
}

.page-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.2s ease, transform 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAEA;EACE,qCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAGA;EACE,wCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAIA;EACE,6BAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAKA;EACE,qCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAMA;EACE,mCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAJF;AAOA;EACE,iCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AALF;AAQA;EACE,oCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AANF;AASA;EACE,oCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AAPF;AAUA;EACE,qCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AARF;AAWA;EACE,sCAAA;EACA,gEAAA;EACA,mBAAA;EACA,kBAAA;AATF;AAYA;EACE,uBAAA;AAVF;;AAaA;EACE,SAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AAVF;;AAaA;EACE,sBAAA;AAVF;;AAaA,qBAAA;AACA;EACE,UAAA;EACA,WAAA;AAVF;;AAaA;EACE,mBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,kBAAA;AAVF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,oBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,eAAA;AAVF;;AAaA,4BAAA;AACA;EACE,eAAA;AAVF;;AAaA;EACE,8BAAA;EACA,wBAAA;EACA,8EAAA;AAVF;;AAaA;EACE,yBAAA;EACA,6EAAA;AAVF;;AAaA;EACE,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,wEAAA;EACA,6DAAA;AAVF;;AAaA;EACE,wEAAA;AAVF;;AAaA;EACE,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,oCAAA;AAVF;;AAaA;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAVF;;AAaA;EACE,eAAA;EACA,MAAA;AAVF;;AAaA,6BAAA;AACA;EACE,2BAAA;AAVF;;AAaA;EACE,2BAAA;AAVF;;AAaA,4BAAA;AACA;EACE,UAAA;EACA,0BAAA;AAVF;;AAaA;EACE,UAAA;EACA,wBAAA;EACA,kDAAA;AAVF","sourcesContent":["@font-face {\n  font-family: 'Helvetica';\n  src: url('./assets/fonts/Helvetica.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'helvetica-lt-std-roman';\n  src: url('./assets/fonts/HelveticaLTStd-Roman.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'helvetica-lt-std-fraction';\n  src: url('./assets/fonts/HelveticaLTStd-Fractions.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'HelveticaLTStd';\n  src: url('./assets/fonts/HelveticaLTStd-Comp.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'HelveticaLTStd-BlkCond';\n  src: url('./assets/fonts/HelveticaLTStd-BlkCond.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'helvetica-world-bold';\n  src: url('./assets/fonts/helvetica-world-bold-1.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'HelveticaLTStd-Obl';\n  src: url('./assets/fonts/HelveticaLTStd-Obl.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Helvetica-Roman-SemiB';\n  src: url('./assets/fonts/Helvetica-Roman-SemiB.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'helvetica-lt-std-bold';\n  src: url('./assets/fonts/HelveticaLTStd-Bold.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'helvetica-lt-std-light';\n  src: url('./assets/fonts/HelveticaLTStd-Light.otf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'helvetica-world-regular';\n  src: url('./assets/fonts/helvetica-world-regular-1.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background-color: #F8FAFC;\n  color: #0F172A;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #FAEFF5;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #A72C68;\n  border-radius: 4px;\n  &:hover {\n    background: #921F58;\n  }\n}\n\n.remove-cursor {\n  pointer-events: none;\n}\n\n.cursor {\n  height: max-content;\n  cursor: pointer;\n}\n\n/* Sweet Alert z-index fix */\n.swal2-container {\n  z-index: 999999;\n}\n\n.swal2-popup {\n  border-radius: 20px !important;\n  padding: 2rem !important;\n  font-family: 'helvetica-lt-std-roman', Helvetica, Arial, sans-serif !important;\n}\n\n.swal2-title {\n  color: #0F172A !important;\n  font-family: 'helvetica-lt-std-bold', Helvetica, Arial, sans-serif !important;\n}\n\n.swal2-confirm {\n  border-radius: 10px !important;\n  padding: 10px 24px !important;\n  font-weight: 500 !important;\n  background: linear-gradient(135deg, #A72C68 0%, #921F58 100%) !important;\n  box-shadow: 0 4px 6px -1px rgba(167, 44, 104, 0.3) !important;\n}\n\n.swal2-confirm:hover {\n  background: linear-gradient(135deg, #921F58 0%, #7E1A4C 100%) !important;\n}\n\n.swal2-cancel {\n  border-radius: 10px !important;\n  padding: 10px 24px !important;\n  font-weight: 500 !important;\n  background: #fff !important;\n  color: #6B7280 !important;\n  border: 1px solid #E5E7EB !important;\n}\n\n.swal2-cancel:hover {\n  background: #FAEFF5 !important;\n  color: #A72C68 !important;\n  border-color: #F0CDDB !important;\n}\n\n.stickyTop {\n  position: fixed;\n  top: 0;\n}\n\n/* MUI table pagination fix */\n.MuiTablePagination-selectLabel {\n  margin-bottom: 0 !important;\n}\n\n.MuiTablePagination-displayedRows {\n  margin-bottom: 0 !important;\n}\n\n/* Smooth page transitions */\n.page-enter {\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n.page-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
